const MODULE = 'SimpleList'
export const FETCH_REQUESTED = `${MODULE}/FETCH_REQUESTED`
export const FETCH_SUCCEEDED = `${MODULE}/FETCH_SUCCEEDED`
export const FETCH_FAILED = `${MODULE}/FETCH_FAILED`
